import FlagDE from './assets/flag-de.svg';
import FlagES from './assets/flag-es.svg';
import FlagFR from './assets/flag-fr.svg';
import FlagGB from './assets/flag-gb.svg';
import FlagIE from './assets/flag-ie.svg';
import FlagNL from './assets/flag-nl.svg';
import FlagIT from './assets/flag-it.svg';
import FlagAT from './assets/flag-at.svg';
import FlagBE from './assets/flag-be.svg';
import FlagCZ from './assets/flag-cz.svg';
import FlagDK from './assets/flag-dk.svg';
import FlagEE from './assets/flag-ee.svg';
import FlagFI from './assets/flag-fi.svg';
import FlagLV from './assets/flag-lv.svg';
import FlagLT from './assets/flag-lt.svg';
import FlagNO from './assets/flag-no.svg';
import FlagPL from './assets/flag-pl.svg';
import FlagPT from './assets/flag-pt.svg';
import FlagSE from './assets/flag-se.svg';
import FlagCH from './assets/flag-ch.svg';

export type CountryCode =
  | 'DE'
  | 'ES'
  | 'FR'
  | 'GB'
  | 'IE'
  | 'NL'
  | 'IT'
  | 'AT'
  | 'BE'
  | 'CZ'
  | 'DK'
  | 'EE'
  | 'FI'
  | 'LV'
  | 'LT'
  | 'NO'
  | 'PL'
  | 'SE'
  | 'PT'
  | 'SE'
  | 'CH';

export const CountryCodeDisplayNames: { [K in CountryCode]: string } = {
  DE: 'Germany',
  ES: 'Spain',
  FR: 'France',
  GB: 'United Kingdom',
  IE: 'Ireland',
  NL: 'Netherlands',
  IT: 'Italy',
  AT: 'Austria',
  BE: 'Belgium',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  EE: 'Estonia',
  FI: 'Finland',
  LV: 'Latvia',
  LT: 'Lithuania',
  NO: 'Norway',
  PL: 'Poland',
  PT: 'Portugal',
  SE: 'Sweden',
  CH: 'Switzerland',
};

// see README.md `Add a new country flag`
export const FLAG_IMPORTS: { [K in CountryCode]: string } = {
  DE: FlagDE,
  ES: FlagES,
  FR: FlagFR,
  GB: FlagGB,
  IE: FlagIE,
  NL: FlagNL,
  IT: FlagIT,
  AT: FlagAT,
  BE: FlagBE,
  CZ: FlagCZ,
  DK: FlagDK,
  EE: FlagEE,
  FI: FlagFI,
  LV: FlagLV,
  LT: FlagLT,
  NO: FlagNO,
  PL: FlagPL,
  PT: FlagPT,
  SE: FlagSE,
  CH: FlagCH,
};

export type Language =
  | 'da'
  | 'nl'
  | 'en'
  | 'et'
  | 'fr'
  | 'de'
  | 'it'
  | 'lv'
  | 'lt'
  | 'no'
  | 'pl'
  | 'pt'
  | 'ro'
  | 'es'
  | 'sv';
export type Currency =
  | 'EUR'
  | 'GBP'
  | 'PLN'
  | 'SEK'
  | 'DKK'
  | 'CHF'
  | 'NOK'
  | 'CZK';

const AIS_OPTION = {
  label: 'AIS',
  value: 'AIS',
};

const PIS_OPTION = {
  label: 'PIS',
  value: 'PIS',
};

const PIS_DONATE_OPTION = {
  label: 'Donate to Unicef',
  value: 'Donate to Unicef',
};

export const CONSENT_OPTION = {
  label: 'Consents',
  value: 'consents',
};

export const UPDATE_MODE_OPTION = {
  label: 'Update Mode',
  value: 'updatemode',
};

export const IDENTITY_MATCH_OPTION = {
  label: 'Identity Match',
  value: 'identitymatch',
};

export const PRODUCT_EXPERIENCE_OPTIONS: { [K in CountryCode]: Array<any> } = {
  DE: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  ES: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  FR: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  GB: [
    AIS_OPTION,
    PIS_OPTION,
    PIS_DONATE_OPTION,
    CONSENT_OPTION,
    UPDATE_MODE_OPTION,
    IDENTITY_MATCH_OPTION,
  ],
  IE: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  NL: [AIS_OPTION, PIS_OPTION, UPDATE_MODE_OPTION, IDENTITY_MATCH_OPTION],
  IT: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  AT: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  BE: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  CZ: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  DK: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  EE: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  FI: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  LV: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  LT: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  NO: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  PL: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  PT: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  SE: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
  CH: [AIS_OPTION, PIS_OPTION, IDENTITY_MATCH_OPTION],
};

export type PageType =
  | 'landing'
  | 'landingV2'
  | 'ais'
  | 'aisV2'
  | 'pis'
  | 'pisV2'
  | 'oauth'
  | 'consents'
  | 'updatemode'
  | 'identitymatch';

export const PaymentSchemes = [
  'LOCAL_DEFAULT',
  'LOCAL_INSTANT',
  'SEPA_CREDIT_TRANSFER',
  'SEPA_CREDIT_TRANSFER_INSTANT',
] as const;
export type PaymentSchemeType = typeof PaymentSchemes[number];

export type PaymentSchemeSelectOptionType = {
  label: string;
  value?: PaymentSchemeType;
  options?: PaymentSchemeSelectOptionType[];
};
export const PAYMENT_SCHEME_OPTIONS: PaymentSchemeSelectOptionType[] = [
  {
    label: 'SEPA',
    options: [
      { label: 'SEPA Credit Transfer', value: 'SEPA_CREDIT_TRANSFER' },
      { label: 'SEPA Instant', value: 'SEPA_CREDIT_TRANSFER_INSTANT' },
    ],
  },
  {
    label: 'Local Transfers',
    options: [
      { label: 'Local Default', value: 'LOCAL_DEFAULT' },
      { label: 'Local Instant', value: 'LOCAL_INSTANT' },
    ],
  },
];
